import { render, staticRenderFns } from "./TransportsFormBlock.vue?vue&type=template&id=2d113cab"
import script from "./TransportsFormBlock.vue?vue&type=script&lang=js"
export * from "./TransportsFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports